// Recovered compiled webpack factory 60296. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { L: () => n });
  let n = (0, i(12115).createContext)({});
}
